import { z } from 'zod';
/**
 * EU/EEA + UK country list for the phone country selector (D-28 allowlist).
 * This is the *full* catalogue; the server narrows it to the countries it
 * currently accepts via GET /phone-countries.  Keeping the lookup table in
 * shared means the UI always has names/ISO codes even before the server
 * responds.
 */
export const EU_EEA_UK_COUNTRIES = [
    { isoCode: 'AT', name: 'Austria', callingCode: '+43' },
    { isoCode: 'BE', name: 'Belgium', callingCode: '+32' },
    { isoCode: 'BG', name: 'Bulgaria', callingCode: '+359' },
    { isoCode: 'CY', name: 'Cyprus', callingCode: '+357' },
    { isoCode: 'CZ', name: 'Czech Republic', callingCode: '+420' },
    { isoCode: 'DE', name: 'Germany', callingCode: '+49' },
    { isoCode: 'DK', name: 'Denmark', callingCode: '+45' },
    { isoCode: 'EE', name: 'Estonia', callingCode: '+372' },
    { isoCode: 'ES', name: 'Spain', callingCode: '+34' },
    { isoCode: 'FI', name: 'Finland', callingCode: '+358' },
    { isoCode: 'FR', name: 'France', callingCode: '+33' },
    { isoCode: 'GB', name: 'United Kingdom', callingCode: '+44' },
    { isoCode: 'GR', name: 'Greece', callingCode: '+30' },
    { isoCode: 'HR', name: 'Croatia', callingCode: '+385' },
    { isoCode: 'HU', name: 'Hungary', callingCode: '+36' },
    { isoCode: 'IE', name: 'Ireland', callingCode: '+353' },
    { isoCode: 'IS', name: 'Iceland', callingCode: '+354' },
    { isoCode: 'IT', name: 'Italy', callingCode: '+39' },
    { isoCode: 'LI', name: 'Liechtenstein', callingCode: '+423' },
    { isoCode: 'LT', name: 'Lithuania', callingCode: '+370' },
    { isoCode: 'LU', name: 'Luxembourg', callingCode: '+352' },
    { isoCode: 'LV', name: 'Latvia', callingCode: '+371' },
    { isoCode: 'MT', name: 'Malta', callingCode: '+356' },
    { isoCode: 'NL', name: 'Netherlands', callingCode: '+31' },
    { isoCode: 'NO', name: 'Norway', callingCode: '+47' },
    { isoCode: 'PL', name: 'Poland', callingCode: '+48' },
    { isoCode: 'PT', name: 'Portugal', callingCode: '+351' },
    { isoCode: 'RO', name: 'Romania', callingCode: '+40' },
    { isoCode: 'SE', name: 'Sweden', callingCode: '+46' },
    { isoCode: 'SI', name: 'Slovenia', callingCode: '+386' },
    { isoCode: 'SK', name: 'Slovakia', callingCode: '+421' },
];
/** Build a calling-code → country lookup for O(1) lookups. */
export const CALLING_CODE_MAP = Object.fromEntries(EU_EEA_UK_COUNTRIES.map((c) => [c.callingCode, c]));
/** Phone country entry as returned by GET /phone-countries. */
export const phoneCountrySchema = z.object({
    isoCode: z.string(),
    name: z.string(),
    callingCode: z.string(),
});
export const phoneCountriesResponseSchema = z.object({
    countries: z.array(phoneCountrySchema),
});
/** Zod schema for the "enter phone number" step (used by both web RHF and mobile). */
export const sendOtpFormSchema = z.object({
    callingCode: z.string().min(2, 'Select a country'),
    nationalNumber: z
        .string()
        .min(4, 'Enter your phone number')
        .max(15, 'Phone number is too long')
        .regex(/^[\d\s\-().]+$/, 'Enter a valid phone number'),
});
/** Zod schema for the "enter 6-digit OTP" step. */
export const verifyOtpFormSchema = z.object({
    code: z
        .string()
        .length(6, 'Enter the 6-digit code')
        .regex(/^\d{6}$/, 'Digits only'),
});
/**
 * Mask a phone number for display: show only the last 3 digits.
 * Example: +447911123456 → ••• ••• •456
 *
 * Safe to call on both E.164 and partial inputs.
 */
export function maskPhoneForDisplay(phone) {
    const digits = phone.replace(/\D/g, '');
    if (digits.length < 3)
        return '•••';
    const last3 = digits.slice(-3);
    return `••• ••• •${last3}`;
}
//# sourceMappingURL=phone.js.map